import { APITypesV1 } from "@cur8/api-client";
import { Visit, VisitHistorySummary } from "@cur8/rich-entity";
import { Sangra75PilotTag } from "render/ui/presentation/Sangra75PilotTag";
import styles from "./styles.module.sass";

export function generateVisitTypeLabel({
  visit,
  visitHistory,
}: {
  visit: Visit;
  visitHistory: VisitHistorySummary;
}) {
  const isBodyScan = visit.medicalExams?.includes(
    APITypesV1.MedicalExam.NekoBodyScan
  );

  if (isBodyScan) {
    const alreadyCheckedIn = visitHistory.attendedVisitIds.includes(
      visit.visitId
    );
    const bodyScanCount =
      visitHistory.medicalExamVisitTimeSeries.nekoBodyScan?.length ?? 0;
    const finalCount = alreadyCheckedIn ? bodyScanCount : bodyScanCount + 1;

    return (
      <span className={styles.visitInfo}>
        {`Body Scan [${finalCount}]`}
        {visit.extendedBloodPanel ? <Sangra75PilotTag /> : null}
      </span>
    );
  }

  const followUpExams = visit.medicalExams?.join(", ");
  return (
    <span className={styles.visitInfo}>{`Follow-up ${followUpExams}`}</span>
  );
}
